<template>
  <div class="container">
    <section class="section">
      <div class="columns">
        <div class="column is-3">
          <navigation></navigation>
        </div>
        <div class="column">
          <router-view :key="$route.name + ($route.params.id || '')"></router-view>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Navigation from '@/components/Forum/Navigation.vue';

export default {
  name: 'Forums',
  components: {
    Navigation,
  },
  metaInfo: {
    title: 'Forum',
    meta: [
      {
        vmid: 'description',
        name: 'description',
        content: 'Get social in Odd Giants with the other players in our forums. Odd Giants Game - developing a new social MMORPG bringing back the beauty of Glitch the Game',
      },
      {
        vmid: 'keywords',
        name: 'keywords',
        content: 'forums, bugs, topics, comments, odd, giants, glitch, game, remake, multiplayer, online, mmorpg',
      },
    ],
  },
};
</script>

<style scoped lang="scss">
</style>
